var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('hypothetical',{attrs:{"mwc-id":_vm.getMwcIdForChild('hypo'),"languageId":_vm.languageId},on:{"languageChanged":_vm.handleLanguageChanged}})}
var staticRenderFns = []

export { render, staticRenderFns }